import React, { Component } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';
import MaterialTable from 'material-table';
import Pomodoro from './pomodoro.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

import './subtask.css'

class Subtask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newItem: '',
      newEstimatedPomodoro: 1,
      description: '',
      editDescription: false,
      subTasks: [],
      mainTask: '',
      pomodoros: 0,
      newestimatedPomodoro: 0,
      error: '',
      showSubTasks: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  addPomodoro = (tempCurrentTask) => {
    tempCurrentTask.pomodoros = (parseInt(tempCurrentTask.pomodoros) + 1).toString();
    this.setState({pomodoros: tempCurrentTask.pomodoros});
    this.props.addPomodoro()
  }

  subtractPomodoro = (tempCurrentTask) => {
    tempCurrentTask.pomodoros = (parseInt(tempCurrentTask.pomodoros) - 1).toString();
    this.setState({pomodoros: tempCurrentTask.pomodoros});
    this.props.subtractPomodoro();
  }

  addPomodoroEstimate = (tempCurrentTask) => {
    tempCurrentTask.estimatedPomodoro = (parseInt(tempCurrentTask.estimatedPomodoro) + 1).toString();
    this.setState({estimatedPomodoro: tempCurrentTask.estimatedPomodoro });
    this.props.addPomodoroEstimate();
  }

  subtractPomodoroEstimate = (tempCurrentTask) => {
    tempCurrentTask.estimatedPomodoro = (parseInt(tempCurrentTask.estimatedPomodoro) - 1).toString();
    this.setState({estimatedPomodoro: tempCurrentTask.estimatedPomodoro });
    this.props.subtractPomodoroEstimate();
  }

  componentDidMount = async() => {
    var rowData = this.props.data;
    console.log("rowData: " + JSON.stringify(rowData))
    const subTasks = await API.graphql(graphqlOperation(queries.listTasks, { filter: { parentTaskId: { eq: rowData.id }}, limit: 999999999}));
    const mainTask = await API.graphql(graphqlOperation(queries.getTask, { id: rowData.id }));
    console.log(subTasks);
    this.setState({subTasks: subTasks, mainTask: mainTask.data.getTask, description: mainTask.data.getTask.description })
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  createTask = async () => {
    console.log('A name was submitted: ' + this.state.newItem);
    console.log('maintask was submitted: ' + JSON.stringify(this.state.mainTask));
    var randomColor = require('randomcolor')
    var color = randomColor({hue: this.state.mainTask.color, alpha: 0.1});

    const todoDetails = {
      name: this.state.newItem,
      description: 'creating a subtask',
      color: color,
      pomodoros: 0,
      estimatedPomodoro: this.state.newEstimatedPomodoro,
      state: 'new',
      deadline: 'none',
      parentTaskId: this.props.data.id
    };
    if (this.state.newItem && this.state.newEstimatedPomodoro) {
      const newTask = await API.graphql(graphqlOperation(mutations.createTask, {input: todoDetails}));
      const subTasks = await API.graphql(graphqlOperation(queries.listTasks, { filter: { parentTaskId: { eq: this.state.mainTask.id }}, limit: 999999999}));
      console.log(newTask);
      this.setState({subTasks: subTasks, error: '', showSubTasks: !this.state.showSubTasks})
    } else {
      this.setState({error: 'Please ensure you fill out all fields'})
    }

  }

  ifErrorPresent = () => {
    if (this.state.error === "") {
      return (<div />)
    } else {
      return (
        <Col xs lg="6">
          <Alert variant={'danger'}>
            { this.state.error }
          </Alert>
        </Col>
      )
    }
  }

  materialTable = () => {
    var rowData = this.props.data
    if (this.state.subTasks.data.listTasks.items.length!==0){
      return (
        <MaterialTable
        columns={[
         { title: 'Subtask', field: 'name'},
         { title: 'Time Spent', field: 'pomodoros', render: rowData => {
           const pomodoroRatio = rowData.pomodoros + "/" + rowData.estimatedPomodoro;
           return (<div>{pomodoroRatio}</div>);
         }},
         { title: 'Deadline', field: 'deadline'},
        ]}
         title={rowData.name + " - Subtasks"}
         data={ this.state.subTasks.data.listTasks.items }
         options={{
           toolbar: false,
           paging: false
         }}
         detailPanel={rowData => {
           return (
             <Subtask
               data={rowData}
               addPomodoro={() => this.addPomodoro(rowData)}
               subtractPomodoro={() => this.subtractPomodoro(rowData)}
               addPomodoroEstimate={() => this.addPomodoroEstimate(rowData)}
               subtractPomodoroEstimate={() => this.subtractPomodoroEstimate(rowData)}>
             </Subtask>
           )
         }}
         root={{backgroundColor: 'blue'}}
         />
      )
    }
  }

  ifShowSubTasks = () => {
    var subTasksDescription = this.props.data.name + " Subtask Description";
    if (this.state.showSubTasks === false) {
      return (<div />)
    } else {
      return (
        <Row>
          <Col xs lg="2">
            <input type="text" style={{ width:"100%" }} value={this.state.newItem} name="newItem" placeholder={subTasksDescription} onChange={this.handleChange} />
          </Col>
          <Col xs lg="2">
            <input type="text" style={{ width:"100%" }} value={this.state.newEstimatedPomodoro} name="newEstimatedPomodoro" placeholder={'Time Interval Estimate'} onChange={this.handleChange} />
          </Col>
          <Col xs lg="2">
            <button onClick={this.createTask}>Add subtask</button>
          </Col>
          { this.ifErrorPresent() }
        </Row>
      )
    }
  }

  description = () => {
    var rowData = this.state.mainTask
    if (this.state.editDescription === false) {
      return (
        <div>
          Description: { rowData.description }
          <button onClick={ this.editDescription }>Edit</button>
        </div>
      )
    } else {
      return (
       <div>
         <input type="text" style={{ width:"100%" }} value={this.state.description} name="description" placeholder={'a description'} onChange={this.handleChange} />
         <button onClick={ this.updateDescription }>Update</button>
       </div>
      )
    }
  }

  editDescription = () => {
    this.setState({editDescription: !this.state.editDescription});
  }

  updateDescription = async () => {
    const main_task = this.state.mainTask
    main_task.description = this.state.description
    let {tableData, ...graphqlUpdatedTask} = main_task;
    console.log(JSON.stringify(graphqlUpdatedTask));
    await API.graphql(graphqlOperation(mutations.updateTask, {input: graphqlUpdatedTask}));
    this.setState({editDescription: !this.state.editDescription, mainTask: graphqlUpdatedTask});
  }

  showSubTasks = () => {
    this.setState({showSubTasks: !this.state.showSubTasks});
  }

  render() {
    var rowData = this.props.data
    const taskArrayData = this.state.subTasks.data;
    if (taskArrayData === undefined) {
      return (<div/>)
    } else {
      return (
        <div>
          <Container fluid="false" style={{ backgroundColor: this.props.data.color }}>
            <Row className="pt1">
              <Col xs lg="4">
                <Pomodoro row={rowData} subTasks={this.state.subTasks} addPomodoro={this.props.addPomodoro} subtractPomodoro={this.props.subtractPomodoro} addPomodoroEstimate={this.props.addPomodoroEstimate} subtractPomodoroEstimate={this.props.subtractPomodoroEstimate} />
              </Col>
              <Col xs md="auto">Color: { rowData.color }</Col>
              <Col xs lg="2">
                { this.description() }

              </Col>
              <Col xs lg="2">
                State: { rowData.state }
              </Col>
              <Col xs lg="2">
                <button onClick={ this.showSubTasks }>Add Subtask</button>
              </Col>
            </Row>
            { this.ifShowSubTasks() }
           <Row className="mt1 pb1">
             <Col xs="12">
               { this.materialTable() }
             </Col>
           </Row>
         </Container>
        </div>
      )
    }
  }
}

export default Subtask;
